import Vue from 'vue'
import Router from 'vue-router'
import PayProtocol from '@/components/protocol/witparking/Pay/PayProtocol'
import ProtocolRouters from './protocol';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'PayProtocol',
      component: PayProtocol
    },
    /*
    * 慧停车协议
    * */
    ProtocolRouters.witparking.PayProtocol,
    ProtocolRouters.witparking.RegisterProtocol,
    ProtocolRouters.witparking.QuickPaymentProtocol,
    ProtocolRouters.witparking.LongRentProtocol,
    ProtocolRouters.witparking.hubProtocol,
    ProtocolRouters.witparking.SharedProtocol,
    ProtocolRouters.witparking.FingerPrintProtocol,
    ProtocolRouters.witparking.PrivacyProtocol,
    ProtocolRouters.witparking.RechargeRegistrationProtocol,
    ProtocolRouters.witparking.RechargeRegistrationProtocolWx,
    ProtocolRouters.witparking.VerifiedProtocol,
    ProtocolRouters.witparking.AccountCancellation,
    ProtocolRouters.witparking.MerchantServices,
    ProtocolRouters.witparking.MerchantServicesForUser,
    ProtocolRouters.witparking.MerchantServicesForPrivacy,
    ProtocolRouters.witparking.OpenElePurseProtocol,
    ProtocolRouters.witparking.AuthorizedInformation,
    ProtocolRouters.witparking.TripartiteSDK,
    ProtocolRouters.witparking.WitGoldCoin, // 慧金币协议
    /*
    * 青岛慧停车协议
    * */
    ProtocolRouters.qingdao.PayProtocol,
    ProtocolRouters.qingdao.RegisterProtocol,
    ProtocolRouters.qingdao.QuickPaymentProtocol,
    ProtocolRouters.qingdao.LongRentProtocol,
    ProtocolRouters.qingdao.SharedProtocol,
    ProtocolRouters.qingdao.FingerPrintProtocol,
    ProtocolRouters.qingdao.PrivacyProtocol,
    /*
    * 重庆慧停车
    * */
    ProtocolRouters.chongqing.PayProtocol,
    ProtocolRouters.chongqing.RegisterProtocol,
    ProtocolRouters.chongqing.QuickPaymentProtocol,
    ProtocolRouters.chongqing.LongRentProtocol,
    ProtocolRouters.chongqing.SharedProtocol,
    ProtocolRouters.chongqing.FingerPrintProtocol,
    ProtocolRouters.chongqing.PrivacyProtocol,
    /*
    * 北京慧停车
    * */
    ProtocolRouters.tongzhou.PayProtocol,
    ProtocolRouters.tongzhou.RegisterProtocol,
    ProtocolRouters.tongzhou.QuickPaymentProtocol,
    ProtocolRouters.tongzhou.LongRentProtocol,
    ProtocolRouters.tongzhou.SharedProtocol,
    ProtocolRouters.tongzhou.FingerPrintProtocol,
    ProtocolRouters.tongzhou.PrivacyProtocol,
    /*
    * 武威慧停车
    * */
    ProtocolRouters.wuwei.PayProtocol,
    ProtocolRouters.wuwei.RegisterProtocol,
    ProtocolRouters.wuwei.QuickPaymentProtocol,
    ProtocolRouters.wuwei.LongRentProtocol,
    ProtocolRouters.wuwei.SharedProtocol,
    ProtocolRouters.wuwei.FingerPrintProtocol,
    ProtocolRouters.wuwei.PrivacyProtocol,
    ProtocolRouters.wuwei.VerifiedProtocol,
    ProtocolRouters.wuwei.AccountCancellation,
    ProtocolRouters.wuwei.MerchantServices,
    ProtocolRouters.wuwei.RechargeRegistration,
    ProtocolRouters.wuwei.RechargeRegistrationWx,
    /*
    * 金山
    * */
    ProtocolRouters.jinshan.RechargeRegistrationProtocolWx,
    ProtocolRouters.jinshan.LongRentProtocol,
    ProtocolRouters.jinshan.PrivacyProtocol,
    ProtocolRouters.jinshan.QuickPaymentProtocol,
    ProtocolRouters.jinshan.RegisterProtocol,
    ProtocolRouters.jinshan.SharedProtocol,
    ProtocolRouters.jinshan.VerifiedProtocol,
    /*
    * 桐庐
    * */
    ProtocolRouters.tonglu.RechargeRegistrationProtocolWx,
    ProtocolRouters.tonglu.LongRentProtocol,
    ProtocolRouters.tonglu.PrivacyProtocol,
    ProtocolRouters.tonglu.QuickPaymentProtocol,
    ProtocolRouters.tonglu.RegisterProtocol,
    ProtocolRouters.tonglu.SharedProtocol,
    ProtocolRouters.tonglu.VerifiedProtocol,
    /*
    * 三明
    * */
    ProtocolRouters.sanming.RechargeRegistrationProtocolWx,
    ProtocolRouters.sanming.LongRentProtocol,
    ProtocolRouters.sanming.PrivacyProtocol,
    ProtocolRouters.sanming.QuickPaymentProtocol,
    ProtocolRouters.sanming.RegisterProtocol,
    ProtocolRouters.sanming.SharedProtocol,
    ProtocolRouters.sanming.VerifiedProtocol,
    /*
    * 青岛慧停车（new）
    * */
    ProtocolRouters.qdsz.LongRentProtocol,
    ProtocolRouters.qdsz.PrivacyProtocol,
    ProtocolRouters.qdsz.QuickPaymentProtocol,
    ProtocolRouters.qdsz.RegisterProtocol,
    ProtocolRouters.qdsz.SharedProtocol,
    ProtocolRouters.qdsz.VerifiedProtocol,
    ProtocolRouters.qdsz.AccountCancellation,
    ProtocolRouters.qdsz.MerchantServices,

    /*
    运维APP
    * */
    ProtocolRouters.witparkingOm.PrivacyProtocol,
    /*
    慧安佳APP
    * */
    ProtocolRouters.witparkingCommunity.PrivacyProtocol,
    ProtocolRouters.witparkingCommunity.ServiceProtocol,
    /*
     * 雄关协议
     * */
    ProtocolRouters.xiongguan.PayProtocol,
    ProtocolRouters.xiongguan.RegisterProtocol,
    ProtocolRouters.xiongguan.QuickPaymentProtocol,
    ProtocolRouters.xiongguan.LongRentProtocol,
    ProtocolRouters.xiongguan.SharedProtocol,
    ProtocolRouters.xiongguan.FingerPrintProtocol,
    ProtocolRouters.xiongguan.PrivacyProtocol,
    ProtocolRouters.xiongguan.RechargeRegistrationProtocol,
    ProtocolRouters.xiongguan.RechargeRegistrationProtocolWx,
    ProtocolRouters.xiongguan.VerifiedProtocol,
    ProtocolRouters.xiongguan.AccountCancellation,

    /*
  * 淄博慧停车协议
  * */
    ProtocolRouters.zibo.PayProtocol,
    ProtocolRouters.zibo.RegisterProtocol,
    ProtocolRouters.zibo.QuickPaymentProtocol,
    ProtocolRouters.zibo.LongRentProtocol,
    ProtocolRouters.zibo.SharedProtocol,
    ProtocolRouters.zibo.FingerPrintProtocol,
    ProtocolRouters.zibo.PrivacyProtocol,
    ProtocolRouters.zibo.RechargeRegistrationProtocol,
    ProtocolRouters.zibo.RechargeRegistrationProtocolWx,
    ProtocolRouters.zibo.VerifiedProtocol,
    ProtocolRouters.zibo.AccountCancellation,
    //和美天山
    ProtocolRouters.hmts.PrivacyProtocolHmts,
    //臻美太湖
    ProtocolRouters.zmth.PrivacyProtocolZmth,
    //慧安佳
    ProtocolRouters.hajmin.PrivacyProtocolHaj,//慧安佳小程序
    ProtocolRouters.hajmin.PrivacyProtocolHajbjtx,//慧安佳便捷通行小程序
    /*
  * 聊城慧停车协议
  * */
    ProtocolRouters.liaocheng.PayProtocol,
    ProtocolRouters.liaocheng.RegisterProtocol,
    ProtocolRouters.liaocheng.QuickPaymentProtocol,
    ProtocolRouters.liaocheng.LongRentProtocol,
    ProtocolRouters.liaocheng.SharedProtocol,
    ProtocolRouters.liaocheng.FingerPrintProtocol,
    ProtocolRouters.liaocheng.PrivacyProtocol,
    ProtocolRouters.liaocheng.RechargeRegistrationProtocol,
    ProtocolRouters.liaocheng.RechargeRegistrationProtocolWx,
    ProtocolRouters.liaocheng.VerifiedProtocol,
    ProtocolRouters.liaocheng.AccountCancellation,
    ProtocolRouters.liaocheng.AuthorizedInformation,
    ProtocolRouters.liaocheng.TripartiteSDK,
    // 渭源智慧泊车协议
    ProtocolRouters.weiyuan.VerifiedProtocol,
    ProtocolRouters.weiyuan.UserProtocol,
    /*
    * 市南慧停车APP协议
    * */
    ProtocolRouters.shinan.PayProtocol,
    ProtocolRouters.shinan.RegisterProtocol,
    ProtocolRouters.shinan.QuickPaymentProtocol,
    ProtocolRouters.shinan.LongRentProtocol,
    ProtocolRouters.shinan.SharedProtocol,
    ProtocolRouters.shinan.FingerPrintProtocol,
    ProtocolRouters.shinan.PrivacyProtocol,
    ProtocolRouters.shinan.RechargeRegistrationProtocol,
    ProtocolRouters.shinan.RechargeRegistrationProtocolWx,
    ProtocolRouters.shinan.VerifiedProtocol,
    ProtocolRouters.shinan.AccountCancellation,
    ProtocolRouters.shinan.MerchantServices,
    ProtocolRouters.shinan.OpenElePurseProtocol,
    /*
    * 连云港港城停车APP协议
    * */
    ProtocolRouters.lyggctc.PayProtocol,
    ProtocolRouters.lyggctc.RegisterProtocol,
    ProtocolRouters.lyggctc.QuickPaymentProtocol,
    ProtocolRouters.lyggctc.LongRentProtocol,
    ProtocolRouters.lyggctc.SharedProtocol,
    ProtocolRouters.lyggctc.FingerPrintProtocol,
    ProtocolRouters.lyggctc.PrivacyProtocol,
    ProtocolRouters.lyggctc.RechargeRegistrationProtocol,
    ProtocolRouters.lyggctc.RechargeRegistrationProtocolWx,
    ProtocolRouters.lyggctc.VerifiedProtocol,
    ProtocolRouters.lyggctc.AccountCancellation,
    ProtocolRouters.lyggctc.MerchantServices,
    ProtocolRouters.lyggctc.OpenElePurseProtocol,
    /*
* 金昌慧停车协议
* */
    ProtocolRouters.jinchang.PayProtocol,
    ProtocolRouters.jinchang.RegisterProtocol,
    ProtocolRouters.jinchang.QuickPaymentProtocol,
    ProtocolRouters.jinchang.LongRentProtocol,
    ProtocolRouters.jinchang.SharedProtocol,
    ProtocolRouters.jinchang.FingerPrintProtocol,
    ProtocolRouters.jinchang.PrivacyProtocol,
    ProtocolRouters.jinchang.RechargeRegistrationProtocol,
    ProtocolRouters.jinchang.RechargeRegistrationProtocolWx,
    ProtocolRouters.jinchang.VerifiedProtocol,
    ProtocolRouters.jinchang.AccountCancellation,
    /* 金昌运维APP */
    ProtocolRouters.jinchangOm.PrivacyProtocol,
    /* 保山小黄牛 */
    ProtocolRouters.baoshan.RegisterProtocol
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js